import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import structuredContent from "./content.json";
import FeedbackForm from "./feedbackform";
import QuizPopup from "./QuizPopup"; // Import the QuizPopup component


const StickyNavbar = ({ onOpenFeedback, openChapterQuestions } ) => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState([]);
  const [isQuestionPopupOpen, setIsQuestionPopupOpen] = useState(false);
const [currentChapterQuestions, setCurrentChapterQuestions] = useState(null);


  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  console.log("isQuestionPopupOpen:", isQuestionPopupOpen);


  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);


  const toggleDropdown = (chapterIndex) => {
    setActiveDropdown(activeDropdown === chapterIndex ? null : chapterIndex);
  };

  // Search logic
  const searchContent = (term) => {
    if (!term) {
      setResults([]);
      return;
    }

    const lowerCaseTerm = term.toLowerCase();

    const searchResults = structuredContent
      .map((chapter) => {
        if (!chapter.content || !Array.isArray(chapter.content)) return null;

        const matches = chapter.content.filter((entry) => {
          // Handle both plain strings and objects with a "text" field
          if (typeof entry === "string") {
            return entry.toLowerCase().includes(lowerCaseTerm);
          } else if (
            typeof entry === "object" &&
            entry.text &&
            typeof entry.text === "string"
          ) {
            return entry.text.toLowerCase().includes(lowerCaseTerm);
          }

          console.warn("Non-string entry found:", entry);
          return false;
        });

        if (matches.length > 0) {
          return {
            chapter: chapter.chapter,
            matches: matches.map((match) => ({
              line:
                typeof match === "object"
                  ? match.line
                  : chapter.content.indexOf(match) + 1,
              text: typeof match === "object" ? match.text : match,
            })),
          };
        }

        return null;
      })
      .filter(Boolean); // Remove null entries

    setResults(searchResults);
  };

  useEffect(() => {
    searchContent(searchTerm);
  }, [searchTerm]);
   // Function to open the questions popup
  //  const openChapterQuestions = (chapter) => {
  //   console.log("Opening questions for:", chapter);
  //   setCurrentChapterQuestions(chapter);
  //   setIsQuestionPopupOpen(true);
  // };
  
  // Function to close the popup
  // const closeQuestionPopup = () => {
  //   setIsQuestionPopupOpen(false);
  //   setCurrentChapterQuestions(null);
  // };

  const chapters = [
    {
      chapter: "Chapter 1",
      sections: [
        { title: "Introduction to Research", href: "/chapter1/video" },
        { title: "Intended Behavioural Outcome (IBO)", href: "/chapter1" },
        { title: "Why Do We Do Research?", href: "/chapter1/SectionOne" },
        { title: "Who Does Research?", href: "/chapter1/SectionTwo" },
        {
          title: "Who takes part in research?",
          href: "/chapter1/SectionThree",
        },
        {
          title: "How Should Research Be Conducted?",
          href: "/chapter1/SectionFour",
        },

        { title: "Chapter Questions", onClick: () => openChapterQuestions("Chapter 1") },
      ],
    },
    {
      chapter: "Chapter 2",
      sections: [
        {
          title: "Research Ethics: Doing research responsibly",
          href: "/chapter2",
        },
        {
          title: "Principles of research ethics",
          href: "/chapter2/principles",
        },
        {
          title: "Misconduct in research practice",
          href: "/chapter2/sectionOne",
        },
        { title: "Group Discussion Topics", href: "/chapter2/sectionTwo" },
        { title: "Chapter Questions", onClick: () => openChapterQuestions("Chapter 2") },
      ],
    },
    {
      chapter: "Chapter 3",
      sections: [
        { title: "Different types of research", href: "/chapter3" },
        { title: "Chapter Questions", onClick: () => openChapterQuestions("Chapter 3") },
      ],
    },
    {
      chapter: "Chapter 4",
      sections: [
        { title: "The Research Cycle", href: "/chapter4/video" },
        { title: "Intended Behavioural Outcome (IBO)", href: "/chapter4" },
        { title: "Stages in the Research Cycle", href: "/chapter4/stages" },
        { title: "Chapter Questions", onClick: () => openChapterQuestions("Chapter 4") },
      ],
    },
    {
      chapter: "Chapter 5",
      sections: [
        { title: "Research Methods", href: "/chapter5/video" },
        { title: "Intended Behavioural Outcome (IBO)", href: "/chapter5" },
        { title: "Data Collection Tools", href: "/chapter5/data" },
        { title: "Data Analysis", href: "/chapter5/sectionTwo" },
        { title: "Storytelling for qualitative data collection and analysis", href: "/chapter5/sectionThree" },
        { title: "Chapter Questions", onClick: () => openChapterQuestions("Chapter 5") },
      ],
    },
    {
      chapter: "Chapter 6: Quality Improvement",
      sections: [
        { title: "Quality Improvement Concepts", href: "/chapter6" },
        // {
        //   title: "Monitoring and Evaluation",
        //   href: "/chapter6",
        // },
        // { title: "Methods for Assessing Quality", href: "/chapter6" },
       
      ],
    },
    {
      chapter: "Chapter 7: Dissemination and Community Engagement",
      sections: [
        { title: "Intended Behavioural Outcome (IBO)", href: "/chapter7" },
        { title: "What is Dissemination?", href: "/chapter7/sectionTwo" },
        {
          title: "Who Should You Share Research With?",
          href: "/chapter7/sectionThree",
        },
        { title: "Chapter Questions", onClick: () => openChapterQuestions("Chapter 7") },
      ],
    },
  
  ];

  return (
    <div className="relative">
      {/* Navbar */}
      <div className="fixed top-0 w-full z-50 bg-[#133E87] text-white px-6 py-4 flex items-center justify-between shadow-md">
        <h1 className="md:text-xl text-xs font-bold">
          CHW
        </h1>
        <button onClick={toggleMenu} className="text-xl focus:outline-none">
          ☰
        </button>
      </div>

      {/* Sidebar Menu */}
      <div
        className={`fixed top-0 left-0 h-full z-10 bg-[#133E87] text-white w-fit p-4 transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300`}
      >
        <button
          onClick={toggleMenu}
          className="absolute top-4 right-4 text-white text-2xl focus:outline-none"
        >
          ✕
        </button>

        <div className="mt-24 px-2 space-y-6 pl-6">
          <Link to="/" className="block text-lg hover:text-gray-200" onClick={() => setIsOpen(false)} >
            Home
          </Link>

          {/* Search Bar */}
          <div className="mb-6 text-black">
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full p-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Search Results */}
          <div>
            {results.length > 0 ? (
              <div className="bg-white shadow-md rounded-lg p-6 mt-6 max-h-96 overflow-y-auto">
                {results.map((result, index) => (
                  <div key={index} className="mb-8">
                    {/* Section Header */}
                    <h2 className="text-xl font-bold text-[#133E87] mb-4">
                      {result.chapter}
                    </h2>
                    {/* Matches List */}
                    <ul className="space-y-3 pl-4">
                      {result.matches.map((match, idx) => (
                        <li
                          key={idx}
                          className="text-sm text-gray-800 bg-gray-100 p-3 rounded-lg"
                        >
                          <strong>Line {match.line}:</strong> {match.text}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            ) : (
              searchTerm && (
                <div className="bg-white shadow-md rounded-lg p-6 mt-6">
                  <p className="text-gray-500 text-center">
                    No results found for "{searchTerm}".
                  </p>
                </div>
              )
            )}
          </div>

   
          <div>
            {chapters.map((item, index) => (
              <div key={index}>
                <div
                  className="cursor-pointer font-semibold text-lg hover:text-gray-200 pt-5"
                  onClick={() => toggleDropdown(index)}
                  
                >
                  {item.chapter}
                </div>
                {activeDropdown === index && (
                  <div className="ml-4 mt-2 mb-5 space-y-4"onClick={() => setIsOpen(false)} >
                    {item.sections.map((section, idx) => (
                      section.onClick ? (
                        <button 
                          key={idx} 
                          onClick={section.onClick} 
                          className="block hover:text-blue-500 text-md"
                        >
                          {section.title}
                        </button>
                      ) : (
                        <Link 
                          key={idx} 
                          to={section.href} 
                          className="block hover:text-blue-500 text-md"
                        >
                          {section.title}
                        </Link>
                      )
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>

          <Link to="/references" className="block text-lg pb-4 hover:text-gray-200 " onClick={() => setIsOpen(false)} >
            References
          </Link>

          <Link onClick={() => setIsOpen(false)} >
            <button
              onClick={onOpenFeedback}
              className="px-4 py-2 bg-blue-700 text-white rounded "      
            >
              Give Feedback
            </button>
          </Link>
          {/* <FeedbackForm
            isOpen={isFeedbackOpen}
            onClose={() => setIsFeedbackOpen(false)}
          /> */}
   
   {/* {isQuestionPopupOpen && (
        <QuizPopup chapter={currentChapterQuestions} onClose={closeQuestionPopup} />
      )} */}
        </div>
        
      </div>
      
    </div>
    
  );
};

export default StickyNavbar;
